<template>
  <section class="margin-top-s campaign-container">
    <div v-if="diffSalesTrack > 0" class="flex w100" style="padding-top: 4px; padding-bottom: 4px;">
        <p><b>Atenção:</b> {{ diffSalesTrack | number }} vendas sem <b>TRACKEAMENTO</b>. Confira se a configuração de UTMS está correta.</p>
    </div>
    <div v-if="accountsFilter && accountsFilter.length > 0" class="flex middle w100">
      <div class="flex-3  flex middle">
        <div class="button secondary" @click="cleanSelectAccounts()">Limpar Seleção</div>
      </div>
    </div>
    <!-- Barra de rolagem superior -->
    <div class="scrollbar-top">
        <div class="scroll-content"></div>
    </div>
    
    <div class="box accounts">
      <div class="box-content">
        <ul class="list-itens">
          
          <li>
            <div class="flex between">
              <div class="flex-3 elem-name">
                  <b>Nome da Conta</b>
              </div>
              <div v-if="columns.spend" class="elem-first-stats  flex-1 txt-center">
                  <b>Valor Gasto</b>
              </div>
              <div v-if="columns.sales" class="flex-1 txt-center">
                  <b>Vendas (CPA)</b>
              </div>
              <div v-if="checkResource('campaigns-track-lh')" class="flex flex-1 lh-info">
                <div v-if="columns.sales_lh" class="flex-1 txt-center">
                  <b>
                    Vendas LH
                    <span class="info tooltip">
                      <span class="tooltiptext">Total e CPA das vendas TRACKEADS. Contando CANCELADAS</span>
                    </span>
                  </b>
                </div>
                <div v-if="columns.value_lh"  class="flex-1 txt-center">
                  <b>
                    Valor LH
                    <span class="info tooltip">
                      <span class="tooltiptext">Valor total das vendas TRACKEADAS. Contando CANCELADAS</span>
                    </span>
                  </b>
                </div>
                <div v-if="columns.sales_p_lh"  class="flex-1 txt-center">
                  <b>
                    Vendas A. LH
                    <span class="info tooltip">
                      <span class="tooltiptext">Total e CPA das vendas APROVADAS. </span>
                    </span>
                  </b>
                </div>
                <div v-if="columns.value_p_lh"  class="flex-1 txt-center">
                  <b>
                    Valor A. LH
                    <span class="info tooltip">
                      <span class="tooltiptext">Valor total das vendas APROVADAS. </span>
                    </span>
                  </b>
                </div>
                <div v-if="columns.lead_lh"  class="flex-1 txt-center">
                  <b>
                    Leads LH
                    <span class="info tooltip">
                      <span class="tooltiptext">Leads capturados pela Único.</span>
                    </span>
                  </b>
                </div>
                <div v-if="columns.message_lh" class="flex-1 txt-center">
                  <b>
                    Conversas LH
                    <span class="info tooltip">
                      <span class="tooltiptext">Conversas capturadas pela Único.</span>
                    </span>
                  </b>
                </div>
                <div v-if="columns.roas_p_lh"  class="flex-1 txt-center">
                  <b>
                    Roas LH
                    <span class="info tooltip">
                      <span class="tooltiptext">Roas feito a partir das VENDAS APROVADAS.</span>
                    </span>
                  </b>
                </div>
                <div v-if="columns.conversion_p_lh"  class="flex-1 txt-center">
                  <b>
                    Tax.Conv
                    <span class="info tooltip">
                      <span class="tooltiptext">Taxa de conversão sobre as VENDAS APROVADAS.</span>
                    </span>
                  </b>
                </div>
              </div>
              <div  v-if="columns.lead" class="flex-1 txt-center">
                  <b>Leads</b>
              </div>
              <div v-if="columns.messages"  class="flex-1 txt-center">
                  <b>Conversas Iniciadas</b>
              </div>
              <div v-if="columns.impression" class="flex-1 txt-center">
                  <b>Impressoes</b>
              </div>
              <div v-if="columns.cpm"  class="flex-1 txt-center">
                  <b>CPM</b>
              </div>
              <div v-if="columns.clicks"  class="flex-1 txt-center">
                  <b>Cliques</b>
              </div>
              <div v-if="columns.ctr"  class="flex-1 txt-center">
                  <b>CTR</b>
              </div>
              <div v-if="columns.conversion"  class="flex-1 txt-center">
                  <b>Tax. Conversão</b>
              </div>
              <div v-if="columns.connect_rate" class="flex-1 txt-center">
                  <b>Connect Rate</b>
              </div>
              <div v-if="columns.pageview" class="flex-1 txt-center">
                  <b>Visualizações da Página</b>
              </div>
              <div v-if="columns.view_content" class="flex-1 txt-center">
                  <b>Visualizações de Conteúdo</b>
              </div>
              <div v-if="columns.add_to_cart" class="flex-1 txt-center">
                  <b>Adições ao Carrinho</b>
              </div>
              <div v-if="columns.initate_checkout" class="flex-1 txt-center">
                  <b>Iniciação de Checkout</b>
              </div>
              <div v-if="columns.add_payment_info" class="flex-1 txt-center">
                  <b>Add Info Pagamento</b>
              </div>
              
            </div>
          </li>

          <li v-for="(camp, index) in accounts" :key="index" class="flex middle w100">
            <div class="flex middle w100" :class="{selected: camp.selected}">
              <!-- name -->
              <div class="flex-3 elem-name flex middle" :class="{selected: camp.selected}">
                <div class="flex middle" >
                  <div class="flex middle">
                    <input type="checkbox" v-model="camp.selected" @change="changeSelectedCamp(camp)"/>
                  </div>
                  <div class="flex column name" style="margin-left: 8px">
                    <div>
                      <i
                        v-if="camp.platform === 'FBADS'"
                        class="fa fa-facebook-square fbads"
                      ></i>
                      <i
                        v-if="camp.platform === 'GADS'"
                        class="fab fa-google gads"
                      ></i>
                      {{ camp.name  | protect }}
                    </div>
                  </div>
                </div>
              </div>
              <!-- spend -->
              <div  v-if="columns.spend" class="elem-first-stats  flex-1 txt-center">
                  {{ getValueC('spend', camp.id) | money }}
              </div>
              <!-- sales fbads/gads -->
              <div  v-if="columns.sales" class="flex-1 txt-center">
                  {{ getValueC('sales', camp.id) | number }} ({{ getValueC('sales_cost', camp.id) | money }})
              </div>
              <div v-if="checkResource('campaigns-track-lh')  && 
                (columns.sales_lh ||columns.value_lh||columns.sales_p_lh||columns.value_p_lh||columns.lead_lh||columns.message_lh||columns.roas_p_lh||columns.conversion_p_lh)" class="flex flex-1  lh-info">
                <!-- sales lh -->
                <div  v-if="columns.sales_lh" class="flex-1 txt-center lh-color">
                    {{ getValueC('sales_lh', camp.id) | number }} ({{ getValueC('sales_lh_cost', camp.id) | money }})
                </div>
                <div v-if="columns.value_lh" class="flex-1 txt-center lh-color">
                    {{ getValueC('value_lh', camp.id) | money }}
                </div>
                <!-- sales aprovado lh -->
                <div  v-if="columns.sales_p_lh" class="flex-1 txt-center lh-color">
                    {{ getValueC('sales_p_lh', camp.id) | number }} ({{ getValueC('sales_p_lh_cost', camp.id) | money }})
                </div>
                <!-- total_value aprovado -->
                <div  v-if="columns.value_p_lh" class="flex-1 txt-center lh-color">
                    {{ getValueC('value_p_lh', camp.id) | money }}
                </div>
                <!--leads -->
                <div  v-if="columns.lead_lh" class="flex-1 txt-center lh-color">
                    {{ getValueC('lead_lh', camp.id) | number }} ({{ getValueC('lead_lh_cost', camp.id) | money }})
                </div>
                <!-- conversation -->
                <div v-if="columns.message_lh"  class="flex-1 txt-center lh-color">
                    {{ getValueC('message_lh', camp.id) | number }} ({{ getValueC('message_lh_cost', camp.id) | money }})
                </div>
                <!-- roas lh -->
                <div v-if="columns.roas_p_lh" class="flex-1 txt-center lh-color">
                    {{ getValueC('roas_p_lh', camp.id) | number }}x
                </div>
                <!-- conver lh -->
                <div v-if="columns.conversion_p_lh"  class="flex-1 txt-center lh-color">
                    {{ getValueC('conversion_p_lh', camp.id) | number }}%
                </div>
              </div>
              <!-- lead -->
              <div  v-if="columns.lead" class="flex-1 txt-center">
                  {{ getValueC('lead', camp.id) | number }} ({{ getValueC('lead_cost', camp.id) | money }})
              </div>
              <!-- messages -->
              <div v-if="columns.messages" class="flex-1 txt-center">
                  {{ getValueC('messages', camp.id) | number }} ({{ getValueC('messages_cost', camp.id) | money }})
              </div>
              <!-- impression -->
              <div v-if="columns.impression"  class="flex-1 txt-center">
                  {{ getValueC('impression', camp.id) | number }}
              </div>
              <!-- cpm -->
              <div  v-if="columns.cpm"  class="flex-1 txt-center">
                  {{ getValueC('cpm', camp.id) | money }}
              </div>
              <!-- clicks -->
              <div v-if="columns.clicks" class="flex-1 txt-center">
                  {{ getValueC('clicks', camp.id) | number }} ({{ getValueC('clicks_cost', camp.id) | money }})
              </div>
              <!-- ctr -->
              <div v-if="columns.ctr" class="flex-1 txt-center">
                  {{ getValueC('ctr', camp.id) | number }}%
              </div>
              <!-- conv -->
              <div  v-if="columns.conversion" class="flex-1 txt-center">
                  {{ getValueC('conversion', camp.id) | number }}%
              </div>
              <!-- connect rate -->
              <div v-if="columns.connect_rate" class="flex-1 txt-center">
                  {{ getValueC('connect_rate', camp.id) | number }}%
              </div>
              <!-- pageview -->
              <div v-if="columns.pageview" class="flex-1 txt-center">
                  {{ getValueC('pageview', camp.id) | number }} ({{ getValueC('pageview_cost', camp.id) | money }})
              </div>
              <!-- view content -->
              <div v-if="columns.view_content" class="flex-1 txt-center">
                  {{ getValueC('view_content', camp.id) | number }} ({{ getValueC('view_content_cost', camp.id) | money }})
              </div>
              <!-- add_to_cart -->
              <div v-if="columns.add_to_cart" class="flex-1 txt-center">
                  {{ getValueC('add_to_cart', camp.id) | number }} ({{ getValueC('add_to_cart_cost', camp.id) | money }})
              </div>
              <!-- initate_checkout -->
              <div v-if="columns.initate_checkout" class="flex-1 txt-center">
                  {{ getValueC('initate_checkout', camp.id) | number }} ({{ getValueC('initate_checkout_cost', camp.id) | money }})
              </div>
              <!-- add_payment_info -->
              <div v-if="columns.add_payment_info" class="flex-1 txt-center">
                  {{ getValueC('add_payment_info', camp.id) | number }} ({{ getValueC('add_payment_info_cost', camp.id) | money }})
              </div>
            </div>
          </li>
        </ul>
        <div v-if="loading">
          <content-loading>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
            <fake-line height="30"></fake-line>
          </content-loading>
        </div>
      </div>
    </div>

    <div class="flex-1 flex row w100 middle">
      <div class="flex w100 center filters-groupo-holder">
        <div class="flex between middle">
            <paginate
              :containerClass="'pagination'"
              :page-count="totalPages"
              v-model="page"
              :page-range="5"
              :prev-text="'Anterior'"
              :next-text="'Próxima'"
            ></paginate>
          </div>
      </div>
    </div>

    <!-- modal confirm delete -->
    <modal-confirm
      :show="showModalSwitchStatus"
      description="Você tem certeza que deseja alterar o Status?"
      @cancel="
        selectedCamp.status = !selectedCamp.status;
        showModalSwitchStatus = false;
        selectedCamp = null;
      "
      @accept="changeStatusCampaign(selectedCamp)"
    ></modal-confirm>

    <modal
        title="Editar Orçamento"
        :show="showUpdateModal"
        @close="showUpdateModal=false;selectedCamp=null"
      >
        <div class="content flex " slot="content">
          <div class="flex column w100">
            <form v-if="selectedCamp" autocomplete="off" class="w100">
              <div class="flex-1 w100 margin-top-m">
                Campanha: {{ selectedCamp.name }}
              </div>
              <div class="flex-1 w100 margin-top-m">
                <label>Orçamento:</label>
                <money v-model="selectedCamp.daily_budget" v-bind="money"></money>
              </div>
            </form>
            <div class="flex w100 center margin-top-l">
              <div class="button secondary" @click="showUpdateModal=false;selectedCamp=null">CANCELAR</div>
              <div class="button primary" @click="changeBulletCampaign(selectedCamp)" style="margin-left: 8px">SALVAR</div>
            </div>
          </div>
        </div>
    </modal>

  </section>
</template>

<script>
import ModalConfirm from "@/components/modal/ModalConfirm";
import Modal from "@/components/modal/Modal";

import { Money } from 'v-money'

import {
  getReportCampaigns,
} from "@/services/campaignsReport";

import { getFilters } from "@/services/filters";


import { mapState } from "vuex";



export default {
  name: "account",
  components: {
    ModalConfirm,
    Money,
    Modal
  },
  props: [
    'filters',
    'columns',
    'accountsFilter'
  ],
  data() {
    return {
      loading: false,
      showModalSwitchStatus: false,
      showUpdateModal: false,
      selectedCamp: null,
      accounts: [],
      reportAccounts: {},
      stats: {},
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: false
      },
      totalItens: 0,
      offset: 20,
      page: 1,
    };
  },
  mounted() {
    this.getAllAccounts();
    this.getReportCampaigns();

    this.syncScrools()
  },
  computed: {
    ...mapState({
      user: (state) => state.user,
      account: (state) => state.account,
    }),
    totalPages() {
      let valueMode = this.totalItens % this.offset;
      let value = this.totalItens / this.offset;

      let pages = 1;

      if (valueMode == 0) {
        pages = value;
      } else {
        pages = parseInt(value) + 1;
      }

      return pages;
    },
    diffSalesTrack() {
      if (!this.stats.sales) {
        return 0
      }

      return this.stats.sales - this.stats.lh_sales
    }
  },
  watch: {
    filters: {
      deep: true,
      handler() {
        this.accounts = []
        this.getAllAccounts()
        this.getReportCampaigns()
      },
    },
    "page": {
      handler() {
        this.accounts = [];
        this.getAllAccounts();
      }
    },
    accountsFilter: {
      handler(value) {
        if (value && value.length === 0) {
          this.accounts.forEach(c => c.selected = false)
        }
      }
    }
  },
  methods: {
    checkResource(name) {
      return (
        this.account &&
        this.account.resources &&
        this.account.resources.includes(name)
      );
    },
    syncScrools() {
      const campaignDiv = document.querySelector('.accounts');
      const listItens = document.querySelector('.list-itens');
      const scrollContent = document.querySelector('.scrollbar-top .scroll-content');
      const topScrollbar = document.querySelector('.scrollbar-top');

      // Função para sincronizar o scroll
      function syncScrollbars() {
          // Sincronizar a rolagem
          topScrollbar.scrollLeft = campaignDiv.scrollLeft;

          // Ajustar a largura da barra de rolagem superior para ser a mesma que a do conteúdo
          // scrollContent.style.width = listItens.scrollWidth + 'px';
          scrollContent.style.width = listItens.scrollWidth + 'px';
          scrollContent.style.height = '10px';
      }

      //Adicionar evento de rolagem para sincronizar as barras
      campaignDiv.addEventListener('scroll', () => {
          topScrollbar.scrollLeft = campaignDiv.scrollLeft;
      });

      // Adicionar evento de rolagem para sincronizar as barras
      topScrollbar.addEventListener('scroll', () => {
        campaignDiv.scrollLeft = topScrollbar.scrollLeft;
      });

      // Sincronizar ao carregar a página e ao redimensionar a janela
      window.addEventListener('load', syncScrollbars);
      window.addEventListener('resize', syncScrollbars);
    },
    getValueC(attr, accountId) {
      if (!this.reportAccounts[accountId]) {
        return 0
      }

      return this.reportAccounts[accountId][attr]
    },
    changeSelectedCamp(camp) {
      if (camp.selected) {
        // camp selected
        this.$emit('accountSelected', camp.id)
      } else {
        // camp not selected
        this.$emit('accountRemoved', camp.id)
      }
    },
    cleanSelectAccounts() {
      this.$emit('cleanAccountSelect')
    },
    getReportCampaigns() {
      const date = this.filters && this.filters.data && this.filters.data.date;

      let params = {
          start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
          end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
          tracking: this.filters && this.filters.data.tracking,
      };
      getReportCampaigns(params)
        .then((result) => {
          this.reportAccounts = result.accounts

          this.stats = result.stats
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
    getAllAccounts() {
      this.loading = true
      const date = this.filters.data.date;
      let params = {
        start_date: date[0] ? date[0].toISOString().slice(0, 10) : "",
        end_date: date[1] ? date[1].toISOString().slice(0, 10) : "",
        tracking: this.filters.data.tracking,

      }
      getFilters(params)
        .then((result) => {
            this.accounts = result.accountAds.map(e => { 
              let platform = "FBADS"
              if (e.label.includes('GADS')) {
                platform = "GADS"
              }
              return {
                id: e.value,
                name: e.label,
                selected: false,
                platform: platform
              }
            })

            this.accounts.forEach(e => {
              if (this.accountsFilter.includes(e.id)) {
                e.selected = true
              }
            });
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu um problema'
          })
        })
      .finally(() => {
        this.loading = false;
      })
    },
  }
};
</script>

<style lang="scss" scoped>
.list-itens {
  width: 5000px;
  
  li {
    list-style-type: none;
    padding: 8px 4px;
    border-bottom: 1px solid #eee;
    font-size: 14px;
    min-height: 53px;
  }
}

.accounts {
  // overflow-x:scroll;
  width: 100%;
  overflow-x: auto;
  
  .input {
    height: 36px;
    min-width: 140px;
    text-align: center;
  }
}

.fbads {
  color: blue;
}
.gads {
  color: red
}
.edit-money {
  padding: 8px !important;
  margin-left: 4px;
  border:0 px !important;
}
.input.input:disabled {
  color: var(--primary)
}
.lh-color {
  color: var(--terciary);
  font-weight: 800;
  background: #ededed;
  // border: 1px solid #c3c3c3;
  padding: 8px 4px;
  // border-radius: 5px;
  // margin-right: 4px;
}



.elem-name {
  width: 600px;
  position: absolute;
  background: var(--boxbg);
  height: 36px;
  padding-right: 20px;
  overflow-x: auto;
  z-index: 2;
  left: 0px;
  padding-left:24px;

  .name {
    padding-right: 8px;
  }
}

.elem-first-stats {
  margin-left: 700px;
}


/* Estilos básicos para a div principal */
.campaign-container {
}

/* Estilo para a barra de rolagem superior */
.scrollbar-top {
    overflow-x: auto;
    overflow-y: hidden;
    height: 20px; /* Tamanho da barra de rolagem */
    margin-bottom: 10px;

    .scroll-content {
      width: 5000px;
    }
}


ul::-webkit-scrollbar {
  width: 10px !important;
  height: 25px !important;
}
ul::-webkit-scrollbar-thumb {
    background-color: #b12031;
    border-radius: 20px;
    border: 10px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
}

/* Estilo para a div de conteúdo com classe campaign */
.accounts {
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    padding-bottom: 28px;
    max-height: 1400px;
}

.selected {
  // background: #e8e8e8;
  background: #EDF2F4;

}


.lh-info {
  min-width: 840px;
}
@media screen and (max-width: 1024px) {
  .elem-name {
    position: relative !important;
    width: 500px !important;
  }
  .elem-first-stats {
    margin-left: 0px !important;
  }
}

</style>
